import { useEffect, useState } from "react";
import { api, fmtEUR } from "@/lib/api";
import { Plus, Trash2, Pencil, X } from "lucide-react";
import { toast } from "sonner";

const EMPTY = { name: "", countries: "PT", rate: 4.9, free_above: 50, carrier: "CTT", estimated_days: "1-3", active: true };

export default function AdminShipping() {
    const [zones, setZones] = useState([]);
    const [edit, setEdit] = useState(null);
    const load = () => api.get("/shipping-zones").then((r) => setZones(r.data));
    useEffect(() => { load(); }, []);

    const save = async (data) => {
        const payload = {
            ...data,
            rate: Number(data.rate),
            free_above: data.free_above ? Number(data.free_above) : null,
            countries: typeof data.countries === "string"
                ? data.countries.split(",").map((c) => c.trim()).filter(Boolean)
                : data.countries,
        };
        if (data.id) await api.put(`/admin/shipping-zones/${data.id}`, payload);
        else await api.post("/admin/shipping-zones", payload);
        toast.success("Zona guardada");
        setEdit(null);
        load();
    };
    const del = async (id) => {
        if (!window.confirm("Eliminar zona?")) return;
        await api.delete(`/admin/shipping-zones/${id}`);
        load();
    };

    return (
        <div data-testid="admin-shipping-page">
            <div className="flex items-center justify-between mb-6">
                <h1 className="font-display font-black text-4xl tracking-tighter">Transporte</h1>
                <button onClick={() => setEdit(EMPTY)} className="btn-primary" data-testid="new-zone-btn">
                    <Plus size={16} /> Nova zona
                </button>
            </div>
            <div className="border-2 border-ink bg-white overflow-x-auto">
                <table className="w-full text-sm">
                    <thead className="bg-ink text-white text-xs font-mono uppercase tracking-wider">
                        <tr>
                            <th className="text-left p-3">Zona</th>
                            <th className="text-left p-3">Países</th>
                            <th className="text-left p-3">Transp.</th>
                            <th className="text-right p-3">Tarifa</th>
                            <th className="text-right p-3">Grátis acima</th>
                            <th className="text-right p-3"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {zones.map((z) => (
                            <tr key={z.id} className="border-t-2 border-ink/10">
                                <td className="p-3 font-bold">{z.name}</td>
                                <td className="p-3 font-mono text-xs">{z.countries.join(", ")}</td>
                                <td className="p-3">{z.carrier}</td>
                                <td className="p-3 text-right font-mono">{fmtEUR(z.rate)}</td>
                                <td className="p-3 text-right font-mono">{z.free_above ? fmtEUR(z.free_above) : "—"}</td>
                                <td className="p-3 text-right">
                                    <button onClick={() => setEdit({ ...z, countries: z.countries.join(", ") })} className="p-1 hover:text-magenta">
                                        <Pencil size={14} />
                                    </button>
                                    <button onClick={() => del(z.id)} className="p-1 hover:text-destructive ml-1">
                                        <Trash2 size={14} />
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            {edit && <ZoneModal initial={edit} onClose={() => setEdit(null)} onSave={save} />}
        </div>
    );
}

function ZoneModal({ initial, onClose, onSave }) {
    const [f, setF] = useState(initial);
    const upd = (k) => (e) => setF((s) => ({ ...s, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value }));
    return (
        <div className="fixed inset-0 bg-ink/60 z-50 flex items-center justify-center p-4">
            <div className="bg-white border-2 border-ink w-full max-w-xl shadow-[8px_8px_0_0_#0A0A0A]">
                <div className="p-5 border-b-2 border-ink flex justify-between">
                    <h2 className="font-display font-black text-2xl">{f.id ? "Editar zona" : "Nova zona"}</h2>
                    <button onClick={onClose}><X size={20} /></button>
                </div>
                <form onSubmit={(e) => { e.preventDefault(); onSave(f); }} className="p-6 grid sm:grid-cols-2 gap-4">
                    <div className="sm:col-span-2"><F label="Nome *" v={f.name} on={upd("name")} required /></div>
                    <div className="sm:col-span-2"><F label="Países (ISO, separar por vírgula) *" v={f.countries} on={upd("countries")} required /></div>
                    <F label="Transportadora" v={f.carrier} on={upd("carrier")} />
                    <F label="Estimativa (dias)" v={f.estimated_days} on={upd("estimated_days")} />
                    <F label="Tarifa (€) *" type="number" step="0.01" v={f.rate} on={upd("rate")} required />
                    <F label="Grátis acima de (€)" type="number" step="0.01" v={f.free_above || ""} on={upd("free_above")} />
                    <div className="sm:col-span-2 flex justify-end gap-3 pt-4 border-t-2 border-ink">
                        <button type="button" onClick={onClose} className="btn-secondary">Cancelar</button>
                        <button type="submit" className="btn-primary">Guardar</button>
                    </div>
                </form>
            </div>
        </div>
    );
}
function F({ label, v, on, type = "text", step, required }) {
    return (
        <label className="block">
            <span className="label-mono mb-2 block">{label}</span>
            <input type={type} step={step} value={v} onChange={on} required={required} className="input-edge" />
        </label>
    );
}
